@import (reference) '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.smart-fill-banner-border {
  align-items: center;
  gap: @space-8;
  width: 100%;
  border: 1px solid transparent;
  border-image-slice: 1;
  border-radius: 6px;
  background-image: @ship-ai--input--gradient-border-image;
  background-origin: border-box;
  background-clip: content-box, border-box;

  .smart-fill-banner-content {
    padding: @space-8;
    width: 100%;
    justify-content: space-between;

    .smart-fill-banner-icon {
      height: 20px;
      width: 20px;
      margin-top: 2px;
      margin-right: @space-4;
    }

    .smart-fill-settings-link {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: @space-4;
    }

    .right-arrow-icon {
      height: 16px;
      width: 16px;
      margin-top: 2px;
    }
  }
}
